module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1506-e61270ceda4f21a004c08ecf7c225770.png";